var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.63 7.672a2.255 2.255 0 0 0-1.587-1.586C17.634 5.7 12 5.7 12 5.7s-5.634 0-7.043.37a2.302 2.302 0 0 0-1.586 1.602C3 9.081 3 12.002 3 12.002s0 2.935.37 4.33a2.255 2.255 0 0 0 1.587 1.586c1.424.385 7.043.385 7.043.385s5.634 0 7.043-.37a2.255 2.255 0 0 0 1.586-1.587c.37-1.409.37-4.33.37-4.33s.016-2.935-.37-4.344Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.207 14.7 14.892 12l-4.685-2.698V14.7Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "youtube_svg__a",
    x: 1,
    y: 3.7,
    width: 22,
    height: 16.602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5063_93284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5063_93284",
    result: "shape"
  })))));
};

export default SvgYoutube;